module.exports = __webpack_public_path__ + "img/comm-02-border-top-01.f9a46d40.png";